function setupSelection() {
    // Get all the aluekohta elements inside suomikartta
    const aluekohtaElements = document.querySelectorAll('.suomikartta .aluekohta');

    if (aluekohtaElements) {
        // Attach click event listeners to each aluekohta element
        aluekohtaElements.forEach((element) => {
        element.addEventListener('click', () => {
            const aluekohtaId = element.id; // Get the ID of the clicked aluekohta element

            // Find the corresponding checkbox based on the value attribute
            const checkbox = document.querySelector(`.alueet input[value="${aluekohtaId}"]`);

            if (checkbox) {
            if (checkbox.checked) {
                checkbox.checked = false; // Uncheck the checkbox
            } else {
                checkbox.checked = true; // Check the checkbox
            }

            element.classList.toggle('active'); // Toggle "active" class on the clicked aluekohta element
            }
        });
        });
    }

    // Get all the checkboxes inside alueet
    const checkboxes = document.querySelectorAll('.alueet input[type="checkbox"]');

    // Attach click event listeners to each checkbox
    if (checkboxes) {
        checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('click', () => {
            const aluekohtaId = checkbox.value; // Get the value of the clicked checkbox

            // Find the corresponding aluekohta element based on the ID
            const aluekohta = document.getElementById(aluekohtaId);

            if (aluekohta) {
            if (checkbox.checked) {
                aluekohta.classList.add('active'); // Add "active" class to the corresponding aluekohta element
            } else {
                aluekohta.classList.remove('active'); // Remove "active" class from the corresponding aluekohta element
            }
            }
        });
        });


        // Read checked checkboxes on page load
        checkboxes.forEach((checkbox) => {
        const aluekohtaId = checkbox.value; // Get the value of the checkbox

        // Find the corresponding aluekohta element based on the ID
        const aluekohta = document.getElementById(aluekohtaId);

        if (aluekohta && checkbox.checked) {
            aluekohta.classList.add('active'); // Add "active" class to the corresponding aluekohta element
        }
        });
    }
  }

  // Call the setupSelection function to set up the behavior
  setupSelection();




  function setupSelection2() {
    // Get all the aluekohta elements inside suomikartta
    const aluekohtaElements = document.querySelectorAll('.suomikartta .aluekohta');

    if (aluekohtaElements) {
        // Attach click event listeners to each aluekohta element
        aluekohtaElements.forEach((element) => {
        element.addEventListener('click', () => {
            const aluekohtaId = element.id; // Get the ID of the clicked aluekohta element

            // Find the select element with the "alueselect" class
            const select = document.querySelector('.alueselect');

            if (select) {
            // Set the value of the select element to the clicked aluekohta's ID
            select.value = aluekohtaId;

            // Remove "active" class from all aluekohta elements
            aluekohtaElements.forEach((element) => {
                element.classList.remove('active');
            });

            element.classList.add('active'); // Add "active" class to the clicked aluekohta element
            }
        });
        });
    }

    // Get the select element with the "alueselect" class
    const select = document.querySelector('.alueselect');

    // Attach change event listener to the select element
    if (select) {
        select.addEventListener('change', () => {
        const selectedValue = select.value;

        // Remove "active" class from all aluekohta elements
        aluekohtaElements.forEach((element) => {
            element.classList.remove('active');
        });

        const selectedElement = document.getElementById(selectedValue);
        if (selectedElement) {
            selectedElement.classList.add('active'); // Add "active" class to the selected aluekohta element
        }
        });
    }
  }

  // Call the setupSelection2 function to set up the behavior
  setupSelection2();




  //kohdekartta
// Get references to the checkboxes and the map div
const naytakarttacheckboxes = document.querySelectorAll('.naytakartta');
const googlemapDiv = document.getElementById('googlemap');

// Add event listener to each checkbox
if (naytakarttacheckboxes.length > 0 && googlemapDiv) {
    naytakarttacheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          // Check if the checkbox is checked
          if (this.checked) {
            // Iterate through the checkboxes and check them
            naytakarttacheckboxes.forEach(function (otherCheckbox) {
              otherCheckbox.checked = true;
            });

            // Show the map div
            googlemapDiv.style.display = 'block';
          } else {
            // Iterate through the checkboxes and uncheck them
            naytakarttacheckboxes.forEach(function (otherCheckbox) {
              otherCheckbox.checked = false;
            });

            // Hide the map div
            googlemapDiv.style.display = 'none';
          }
        });
      });
}
